import { render, staticRenderFns } from "./Breadcumbs.vue?vue&type=template&id=ce5d397e&"
import script from "./Breadcumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports